/** Map Portal layer actions gated by role. */
export enum LayerAction {
  // Values are the menu labels themselves — LayerOption dispatches on the label.
  ZOOM_TO_LAYER = 'Zoom to Layer',
  SHOW_PROPERTIES = 'Show Properties',
  SHOW_TABLE = 'Show Table',
  DOWNLOAD_LAYER = 'Download Layer',
  DUPLICATE_LAYER = 'Duplicate Layer',
  SAVE_LAYER_AS = 'Save Layer As',
  REMOVE_LAYER = 'Remove Layer',
  CREATE_GROUP = 'Create Group',
  LAYER_PERMISSIONS = 'Layer Permissions',
  RE_UPLOAD_DATA = 'Re-Upload Data',

  // Reached by a drag, a blur or a footer button rather than a menu row.
  REORDER_LAYERS = 'reorderLayers',
  MANAGE_GROUPS = 'manageGroups',
  SAVE_LAYER = 'saveLayer',
  EDIT_LAYER_PROPERTIES = 'editLayerProperties',
  MANAGE_LAYER_PERMISSIONS = 'manageLayerPermissions',
  OPEN_CREATE_FEATURE = 'openCreateFeature',
}

/** Map Portal tool-level actions gated by role — distinct from per-layer actions. */
export enum MapToolAction {
  OPEN_MAP_SETTINGS = 'openMapSettings',
  SAVE_TABLE_RESULTS = 'saveTableResults',
}
